<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'poiCrud'"
          :crudName="$t('poi.crud.title')"
          :newText="$t('poi.crud.newText')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('cadastro.gerenciar')"
          :enableEdit="$hasAbility('cadastro.gerenciar')"
          :enableDelete="$hasAbility('cadastro.gerenciar')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "poiTable",
      showMessageImport: false,
      poiCrud: {},
      pages: [],
      url: "",
      columns: ["id", "name", "type", "status", "actions"],
      tableData: ["id", "name", "type", "status"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: this.$t("poi.crud.nameColumn"),
          type: this.$t("poi.crud.typeColumn"),
          status: this.$t("common.status"),
          actions: this.$t("common.actions"),
        },
        sortable: ["id", "name", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: this.$t("poi.crud.filterBy"),
          defaultOption: this.$t("common.select"),
        },
        listColumns: {
          status: [
            { id: 1, text: this.$t("common.active") },
            { id: 0, text: this.$t("common.inactive") },
          ],
        },
        templates: {
          type: (h, row) => {
            return row.type ? row.type.name : "";
          },
          status: (h, row) => {
            return row.status == 1
              ? this.$t("common.active")
              : this.$t("common.inactive");
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["type"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "pois",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = { id: "id", name: "name", status: "status" };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
